export default __webpack_public_path__ + "static/media/logo.3e179e17.svg";